// @ts-nocheck
import { FC, useState, ChangeEvent, FormEvent } from "react";
import styled from "styled-components";
import colors from "../../../styles/colors";

interface FormErrors {
    name?: string;
    state?: string;
    city?: string;
    file_avatar_arena?: string;
    general?: string;
}

interface CreateArenaModaleProps {
    closeModalClick: () => void;
    onSave?: (formData: FormData) => Promise<void>;
}

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

const ModalDialog = styled.div`
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 28px auto;
    pointer-events: none;
`;

const ModalContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: ${colors.bgColorBlack2};
    color: white;
    background-clip: padding-box;
    border: 5px solid gold;
    border-radius: 5px;
    outline: 0;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 16px;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    gap: 12px;
`;

const ModalHeaderTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const ModalTitle = styled.h5`
    margin: 0;
    line-height: 1.5;
    font-size: 20px;
    font-weight: 500;
    color: gold;
`;

const CloseButton = styled.button`
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 4px;
    color: white;
    border: 0;
    border-radius: 4px;
    opacity: 0.5;
    background: transparent;
    cursor: pointer;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;

    &:hover {
        opacity: 0.75;
    }

    &:before {
        content: "×";
    }
`;

const ModalBody = styled.div`
    position: relative;
    flex: 1 1 auto;
    padding: 16px;
`;

const ModalFooter = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    padding: 12px;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    gap: 8px;
`;

const FormGroup = styled.div`
    margin-bottom: 16px;
`;

const FormLabel = styled.label`
    display: inline-block;
    margin-bottom: 8px;
    font-weight: 500;
    color: gold;
`;

const FormInput = styled.input`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }

    &[type="file"] {
        padding: 8px;
        cursor: pointer;

        &::file-selector-button {
            padding: 6px 12px;
            margin-right: 12px;
            border: 1px solid #d3d3d3;
            border-radius: 4px;
            background-color: #f8f9fa;
            color: #000000;
            cursor: pointer;
            font-size: 14px;
            transition: background-color 0.15s ease-in-out;

            &:hover {
                background-color: #e9ecef;
            }
        }
    }
`;

const FormSelect = styled.select`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    margin-bottom: 8px;

    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
`;

const StateInputContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const Button = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #ffffff;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 16px;
    border-radius: 4px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;

const ButtonPrimary = styled(Button)`
    color: white;
    background-color: #0d6efd;
    border-color: #0d6efd;

    &:hover:not(:disabled) {
        color: white;
        background-color: #0b5ed7;
        border-color: #0a58ca;
    }
`;

const ButtonSecondary = styled(Button)`
    color: #ffffff;
    background-color: #6c757d;
    border-color: #6c757d;

    &:hover:not(:disabled) {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
    }
`;

const ErrorText = styled.p`
    margin-top: 6px;
    margin-bottom: 0;
    color: #dc3545;
    font-size: 14px;
`;

const PREDEFINED_STATES: string[] = [
    "USA",
    "Italy",
    "France",
    "Germany",
    "Spain",
    "United Kingdom",
    "Canada",
    "Mexico",
    "Japan",
    "Australia"
];

const CreateArenaModale: FC<CreateArenaModaleProps> = ({ closeModalClick, onSave }) => {
    const [name, setName] = useState<string>("");
    const [state, setState] = useState<string>("");
    const [customState, setCustomState] = useState<string>("");
    const [city, setCity] = useState<string>("");
    const [fileAvatarArena, setFileAvatarArena] = useState<File | null>(null);
    const [errors, setErrors] = useState<FormErrors>({});
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const handleStateSelectChange = (e: ChangeEvent<HTMLSelectElement>): void => {
        const value = e.target.value;
        setState(value);
        if (value && value !== "") {
            setCustomState("");
        }
    };

    const handleCustomStateChange = (e: ChangeEvent<HTMLInputElement>): void => {
        const value = e.target.value;
        setCustomState(value);
        if (value && value.trim() !== "") {
            setState("");
        }
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();
        setErrors({});

        const nextErrors: FormErrors = {};
        if (!name || name.trim().length === 0) nextErrors.name = "Inserisci un nome";

        const finalState = customState.trim() || state;
        if (!finalState || finalState.length === 0) {
            nextErrors.state = "Inserisci uno stato";
        }

        if (!city || city.trim().length === 0) nextErrors.city = "Inserisci una città";

        if (Object.keys(nextErrors).length > 0) {
            setErrors(nextErrors);
            return;
        }

        const formData = new FormData();
        formData.append('name', name.trim());
        formData.append('state', finalState);
        formData.append('city', city.trim());
        if (fileAvatarArena) {
            formData.append('file_avatar_arena', fileAvatarArena);
        }

        setIsSaving(true);
        try {
            if (onSave) {
                await onSave(formData);
            } else {
                console.log("Salvataggio Arena (placeholder):", formData);
            }
            closeModalClick();
        } catch (error) {
            console.error("Errore durante il salvataggio:", error);
            const err = error as Error;
            setErrors({ general: err?.message || "Errore durante il salvataggio. Riprova." });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Container className="create-arena-modale-container">
            <ModalDialog className="create-arena-modale-dialog">
                <ModalContent className="create-arena-modale-content">
                    <form onSubmit={handleSubmit} className="create-arena-modale-form">
                        <ModalHeader className="create-arena-modale-header">
                            <ModalHeaderTop className="create-arena-modale-header-top">
                                <ModalTitle className="create-arena-modale-title">
                                    Aggiungi Arena
                                </ModalTitle>
                                <CloseButton
                                    type="button"
                                    aria-label="Close"
                                    onClick={closeModalClick}
                                    className="create-arena-modale-close-button"
                                />
                            </ModalHeaderTop>
                        </ModalHeader>
                        <ModalBody className="create-arena-modale-body">
                            <FormGroup className="create-arena-modale-form-group">
                                <FormLabel htmlFor="name" className="create-arena-modale-label">
                                    Nome *
                                </FormLabel>
                                <FormInput
                                    id="name"
                                    type="text"
                                    value={name}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                                    placeholder="Inserisci nome..."
                                    className="create-arena-modale-input"
                                />
                                {errors.name && (
                                    <ErrorText className="create-arena-modale-error-text">
                                        {errors.name}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            <FormGroup className="create-arena-modale-form-group">
                                <FormLabel htmlFor="state" className="create-arena-modale-label">
                                    Stato *
                                </FormLabel>
                                <StateInputContainer>
                                    <FormSelect
                                        id="state"
                                        value={state}
                                        onChange={handleStateSelectChange}
                                        className="create-arena-modale-select"
                                    >
                                        <option value="">Seleziona uno stato</option>
                                        {PREDEFINED_STATES.map((s: any) => (
                                            <option key={s} value={s}>
                                                {s}
                                            </option>
                                        ))}
                                    </FormSelect>
                                    <FormInput
                                        id="custom_state"
                                        type="text"
                                        value={customState}
                                        onChange={handleCustomStateChange}
                                        placeholder="Oppure inserisci uno stato personalizzato..."
                                        className="create-arena-modale-input"
                                    />
                                </StateInputContainer>
                                {errors.state && (
                                    <ErrorText className="create-arena-modale-error-text">
                                        {errors.state}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            <FormGroup className="create-arena-modale-form-group">
                                <FormLabel htmlFor="city" className="create-arena-modale-label">
                                    Città *
                                </FormLabel>
                                <FormInput
                                    id="city"
                                    type="text"
                                    value={city}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
                                    placeholder="Inserisci città..."
                                    className="create-arena-modale-input"
                                />
                                {errors.city && (
                                    <ErrorText className="create-arena-modale-error-text">
                                        {errors.city}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            <FormGroup className="create-arena-modale-form-group">
                                <FormLabel htmlFor="file_avatar_arena" className="create-arena-modale-label">
                                    Avatar Arena
                                </FormLabel>
                                <FormInput
                                    id="file_avatar_arena"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFileAvatarArena(e.target.files?.[0] || null)}
                                    className="create-arena-modale-input"
                                />
                                {errors.file_avatar_arena && (
                                    <ErrorText className="create-arena-modale-error-text">
                                        {errors.file_avatar_arena}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            {errors.general && (
                                <ErrorText className="create-arena-modale-error-text">
                                    {errors.general}
                                </ErrorText>
                            )}
                        </ModalBody>
                        <ModalFooter className="create-arena-modale-footer">
                            <ButtonSecondary
                                type="button"
                                onClick={closeModalClick}
                                className="create-arena-modale-button-secondary"
                                disabled={isSaving}
                            >
                                Chiudi
                            </ButtonSecondary>
                            <ButtonPrimary
                                type="submit"
                                className="create-arena-modale-button-primary"
                                disabled={isSaving}
                            >
                                {isSaving ? "Salvataggio..." : "Salva"}
                            </ButtonPrimary>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </ModalDialog>
        </Container>
    );
};

export default CreateArenaModale;
